export const testimonials = [
  {
    id: 1,
    name: "Özkan K.",
    role: "Genel Müdür",
    company: "E Ofis",
    rating: 5,
    text: "Biff'le çalışmaya başladığımızdan beri dijital performansımız patladı. Kampanyaları en doğru kanallara yerleştirdiler, her adımı raporladılar. Komuta merkezinde olduğumuzu hissettik resmen!",
  },
  {
    id: 2,
    name: "Alpcan G.",
    role: "Pazarlama Direktörü",
    company: "Ethos",
    rating: 5,
    text: "Biff'in stratejik öngörüleri sayesinde sosyal medya etkileşimlerimiz %150 fırladı. Reklam bütçemizi yarıya düşürürken dönüşümlerimizi ikiye katladılar. İşi gerçekten biliyorlar.",
  },
  {
    id: 3,
    name: "Ramazan U.",
    role: "Satış ve Pazarlama Müdürü",
    company: "Akyapı",
    rating: 5,
    text: "E-ihracat raporlamaları bizim dönüm noktamız oldu. Hedef pazar analizleri ve lojistik optimizasyonla yurtdışı satışlarımız ilk üç ayda %120 yükseldi. Biff tam bir büyüme motoru.",
  },
];